class progressListener {
  callbacks = [];

  subscribe(callback) {
    this.callbacks.push(callback);
    return () => {
      this.callbacks = this.callbacks.filter(
        eventCallback => eventCallback !== callback
      );
    };
  }
  progress(currentTime, duration) {
    this.callbacks.forEach(fn => {
      fn(currentTime, duration);
    });
  }
}

export default new progressListener();



// WEBPACK FOOTER //
// ./src/components/global/playlist/lib/progressListener.js